import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "pr-3",
    style: _vm.hierarchyIndices.length === 0 ? 'overflow-x: auto; overflow-y: visible' : `padding-left: ${_vm.indentWidth}px`
  }, [_c('div', {
    staticClass: "drawerlinks my-0"
  }, [_vm._l(_vm.linkItems, function (linkItem, j) {
    return _c('div', {
      key: `link_item_${j}`
    }, [_c('div', {
      staticClass: "mx-1 mb-2",
      staticStyle: {
        "display": "flex",
        "flex-direction": "column"
      }
    }, [_c('div', {
      staticStyle: {
        "display": "flex",
        "flex-direction": "row",
        "align-items": "center",
        "min-width": "620px"
      }
    }, [_c('div', {
      staticClass: "mx-1",
      staticStyle: {
        "display": "flex",
        "width": "80px"
      }
    }, [_c('core-button', {
      attrs: {
        "color": _vm.color,
        "disabled": j === _vm.linkItems.length - 1,
        "prepend-icon": "fa-chevron-down"
      },
      on: {
        "click": function ($event) {
          return _vm.changeDrawerLinksOrder(j, 'down');
        }
      }
    }), _c('core-button', {
      attrs: {
        "color": _vm.color,
        "disabled": j === 0,
        "prepend-icon": "fa-chevron-up"
      },
      on: {
        "click": function ($event) {
          return _vm.changeDrawerLinksOrder(j, 'up');
        }
      }
    })], 1), _c('div', {
      staticClass: "mx-1",
      staticStyle: {
        "display": "flex",
        "align-items": "center"
      }
    }, [_c(VSelect, {
      staticClass: "linkitem-type required",
      attrs: {
        "disabled": _vm.disabled,
        "items": _vm.linkItemTypes,
        "color": _vm.color,
        "outlined": _vm.inpOutlined,
        "filled": _vm.inpFilled,
        "rules": _vm.requiredRule,
        "hide-details": "",
        "label": _vm.$i18n_t('BackgroundJobs.BackgroundJobs.table.type')
      },
      on: {
        "change": function ($event) {
          return _vm.changedLinkItemType(j);
        }
      },
      model: {
        value: linkItem.type,
        callback: function ($$v) {
          _vm.$set(linkItem, "type", $$v);
        },
        expression: "linkItem.type"
      }
    })], 1), _c('div', {
      staticClass: "mx-1",
      staticStyle: {
        "display": "flex"
      }
    }, [linkItem.type !== 'category' ? _c(VTextField, {
      staticClass: "linkitem-text required",
      attrs: {
        "disabled": _vm.disabled,
        "color": _vm.color,
        "outlined": _vm.inpOutlined,
        "filled": _vm.inpFilled,
        "rules": _vm.requiredRule,
        "required": "",
        "hide-details": "",
        "label": "LINKTEXT"
      },
      on: {
        "change": function ($event) {
          return _vm.emitChange();
        }
      },
      model: {
        value: linkItem.text,
        callback: function ($$v) {
          _vm.$set(linkItem, "text", $$v);
        },
        expression: "linkItem.text"
      }
    }) : _c(VTextField, {
      staticClass: "linkitem-text required",
      attrs: {
        "disabled": _vm.disabled,
        "color": _vm.color,
        "outlined": _vm.inpOutlined,
        "filled": _vm.inpFilled,
        "rules": _vm.requiredRule,
        "required": "",
        "hide-details": "",
        "label": ""
      },
      on: {
        "change": function ($event) {
          return _vm.emitChange();
        }
      },
      model: {
        value: linkItem.category,
        callback: function ($$v) {
          _vm.$set(linkItem, "category", $$v);
        },
        expression: "linkItem.category"
      }
    })], 1), linkItem.type !== 'category' ? [_c('div', {
      staticClass: "mx-1",
      staticStyle: {
        "display": "flex",
        "width": "230px"
      }
    }, [_c('core-icons', {
      attrs: {
        "faStyle": "light",
        "disabled": _vm.disabled,
        "required": "",
        "dense": ""
      },
      on: {
        "input": function ($event) {
          return _vm.emitChange();
        }
      },
      model: {
        value: linkItem.icon,
        callback: function ($$v) {
          _vm.$set(linkItem, "icon", $$v);
        },
        expression: "linkItem.icon"
      }
    })], 1), linkItem.type === 'link' ? _c('div', {
      staticClass: "mx-1",
      staticStyle: {
        "display": "flex",
        "max-width": "200px"
      }
    }, [_c(VSelect, {
      staticClass: "required",
      attrs: {
        "items": _vm.routerPaths,
        "disabled": _vm.disabled,
        "color": _vm.color,
        "outlined": _vm.inpOutlined,
        "filled": _vm.inpFilled,
        "rules": _vm.requiredRule,
        "required": "",
        "hide-details": "",
        "label": "TARGET"
      },
      on: {
        "change": function ($event) {
          return _vm.emitChange();
        }
      },
      model: {
        value: linkItem.to,
        callback: function ($$v) {
          _vm.$set(linkItem, "to", $$v);
        },
        expression: "linkItem.to"
      }
    })], 1) : _vm._e(), linkItem.permissionJsonError ? _c('div', {
      staticClass: "mx-1",
      staticStyle: {
        "display": "flex"
      }
    }, [_c(VTextField, {
      staticClass: "required",
      attrs: {
        "value": linkItem.permissionJsonError,
        "disabled": _vm.disabled,
        "color": _vm.color,
        "outlined": _vm.inpOutlined,
        "filled": _vm.inpFilled,
        "rules": [() => 'Invalid JSON'],
        "required": "",
        "error": "",
        "hide-details": "",
        "label": ""
      }
    })], 1) : _vm._e(), _c('div', {
      staticClass: "mx-0",
      staticStyle: {
        "display": "flex"
      }
    }, [_c('core-button', {
      attrs: {
        "color": _vm.color,
        "title": _vm.$i18n_t('DigitalTwin.DigitalTwin.types.floor'),
        "prepend-icon": "fa-user-lock"
      },
      on: {
        "click": function ($event) {
          return _vm.togglePermissionEditor(j);
        }
      }
    }), _c('core-button', {
      attrs: {
        "color": _vm.color,
        "title": _vm.$i18n_t('Common.delete'),
        "prepend-icon": "fa-trash-alt"
      },
      on: {
        "click": function ($event) {
          return _vm.removeLinkItem(j);
        }
      }
    }), !_vm.disabled && linkItem.type === 'group' ? _c('core-button', {
      attrs: {
        "color": _vm.color,
        "title": 'ADD GROUP ITEM',
        "prepend-icon": "fa-plus"
      },
      on: {
        "click": function ($event) {
          return _vm.addGroupItem(j);
        }
      }
    }) : _vm._e()], 1)] : _vm._e()], 2)]), _vm.codeMirrorInstances[j] ? _c('div', {
      staticClass: "mx-1 mb-2"
    }, [_c('codemirror', {
      ref: `codemirror_nested_${_vm.hierarchyIndices}_${j}`,
      refInFor: true,
      staticClass: "elevation-3",
      attrs: {
        "options": _vm.cmOptions
      },
      on: {
        "focus": function ($event) {
          return _vm.onCmFocus(j);
        },
        "change": function ($event) {
          return _vm.finishedPermissionEditing(linkItem);
        },
        "blur": function ($event) {
          return _vm.finishedPermissionEditing(linkItem);
        }
      },
      model: {
        value: linkItem.permissionsJsonString,
        callback: function ($$v) {
          _vm.$set(linkItem, "permissionsJsonString", $$v);
        },
        expression: "linkItem.permissionsJsonString"
      }
    })], 1) : _vm._e(), linkItem.type === 'group' ? [_c('div', {
      staticStyle: {
        "display": "flex",
        "flex-direction": "row"
      }
    }, [_c('core-tenant-drawer-links-edit', {
      key: `nested_${_vm.hierarchyIndices}`,
      attrs: {
        "tenantTheme": _vm.tenantTheme,
        "disabled": _vm.disabled,
        "hierarchyIndices": _vm.hierarchyIndices.concat(j)
      },
      on: {
        "remove": function ($event) {
          return _vm.removeLinkItem(j);
        },
        "drawerlinks-changed": function ($event) {
          return _vm.emitChange();
        }
      }
    })], 1)] : _vm._e()], 2);
  }), _vm.hierarchyIndices.length === 0 ? _c('div', {
    staticStyle: {
      "display": "flex"
    }
  }, [_c('div', {
    staticStyle: {
      "display": "flex"
    }
  }), _c('div', {
    staticClass: "mx-1 my-0"
  }, [!_vm.disabled ? _c('core-button', {
    attrs: {
      "color": _vm.color,
      "title": _vm.$i18n_t('Common.addNew'),
      "prepend-icon": "fa-plus"
    },
    on: {
      "click": _vm.addLinkItem
    }
  }) : _vm._e(), !_vm.disabled && _vm.hierarchyIndices.length > 0 ? _c('core-button', {
    attrs: {
      "color": _vm.color,
      "title": _vm.$i18n_t('Common.delete'),
      "prepend-icon": "fa-trash-alt"
    },
    on: {
      "click": _vm.removeLinkItems
    }
  }) : _vm._e()], 1)]) : _vm._e()], 2)]);
};
var staticRenderFns = [];
export { render, staticRenderFns };